import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class PrevServiceContainerService {
  private host =
    environment.configCMS.endPointAPI + environment.configCMS.endPointAPP;

  constructor(private router: Router, private http: HttpClient) {}

  public getServicos(id: string): Observable<any> {
    return this.getServicosContents(id).pipe(
      map(res => this.mapServices(this.extractResult(res))),
      catchError(error => {
        console.log('error', error);
        this.router.navigate(['/nao-encontrado']);
        return of(null);
      })
    );
  }

  private extractResult(res) {
    return res.data.queryServicosContents?.length > 0 ? res.data.queryServicosContents[0].data : null;
  }

  private getServicosContents(id: string): Observable<any> {
    const payload = {
      query: `
      {
        queryServicosContents(filter: "id eq '${id}'"){
          data {
            titulo {
              iv
            }
            subtitulo {
              iv
            }
            descricao {
              iv
            }
            heightImg {
              iv
            }
            botoes {
              iv {
                cor
                uRL
                pagina {
                  data {
                    slug {
                      iv
                    }
                  }
                }
                modal {
                  id
                }
                titulo
              }
            }
            dicas {
              iv {
                descricao
              }
            }
            icones {
              iv {
                imagem {
                  url
                }
                titulo
                uRL
                pagina {
                  data {
                    slug {
                      iv
                    }
                  }
                }
                modal {
                  id
                }
              }
            }
            imagem {
              iv {
                url
              }
            }
            corDestaque {
              iv
            }
            links {
              iv {
                title
                modal {
                  id
                }
                page {
                  data {
                    slug {
                      iv
                    }
                  }
                }
              }
            }
            imagemPrimeiro {
              iv
            }
            espacoAbaixo {
              iv
            }
          }
        }
      }`
    };

    return this.send(payload);
  }

  public mapServices(response) {
    let buttons = [];
    if (response.botoes) {
      buttons = response.botoes.iv.map(button => {
        let externalURL = false;
        if (button.uRL) {
          if (button.uRL.indexOf('http') >= 0) {
            externalURL = true;
          }
        }
        return {
          color: button.cor,
          title: button.titulo,
          url: button.uRL,
          router: externalURL ? null : button.uRL ? button.uRL : null,
          hrefTarget: externalURL ? '_blank' : null,
          modal: button.modal && button.modal[0] ? button.modal[0].id : '',
          target: button.target && button.target[0] ? button.target[0].id : '',
          page:
            button.pagina && button.pagina.length > 0
              ? '/paginas/' + button.pagina[0].data.slug.iv
              : ''
        };
      });
    }

    let icons = [];
    if (response.icones) {
      icons = response.icones.iv.map(icon => {
        return {
          title: icon.titulo,
          image: icon.imagem ? icon.imagem[0].url : null,
          url: icon.uRL || '',
          modal: icon.modal && icon.modal[0] ? icon.modal[0].id : '',
          page:
            icon.pagina && icon.pagina.length > 0
              ? '/paginas/' + icon.pagina[0].data.slug.iv
              : ''
        };
      });
    }
    let tips;
    if (response.dicas !== null && response.dicas !== undefined) {
      tips = response.dicas.iv.map(tip => {
        return {
          description: tip.descricao
        };
      });
    } else {
      tips = response.dicas;
    }
    const hasHighlightColor =
      response.corDestaque !== null && response.corDestaque !== undefined;
    const hasDescription =
      response.descricao !== null && response.descricao !== undefined;

    let links = [];
    if (response.links) {
      links = response.links.iv.map(link => {
        return {
          title: link.title || '',
          page: link.page && link.page?.length > 0 ? '/paginas/' + link.page[0].data?.slug?.iv : '',
          modal: link.modal && link.modal?.length > 0 ? link.modal[0].id : ''
        };
      });
    }

    return {
      buttons,
      highlightColor: hasHighlightColor
        ? response.corDestaque.iv
        : response.corDestaque,
      tips,
      icons,
      image: response.imagem ? response.imagem.iv[0].url : null,
      subtitle: response.subtitulo ? response.subtitulo.iv : '',
      description: hasDescription ? response.descricao.iv : '',
      heightImg: response.heightImg ? response.heightImg.iv : null,
      title: response.titulo ? response.titulo.iv : '',
      imgFirst: response.imagemPrimeiro ? response.imagemPrimeiro.iv : null,
      marginBottom: response.espacoAbaixo ? response.espacoAbaixo.iv : null,
      links
    };
  }

  private send(payload): Observable<any> {
    const url = `${this.host}graphql`;
    return this.http.post(url, payload);
  }
}
